import { render } from "./TabContent.vue?vue&type=template&id=ecb7f78e&scoped=true"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"

import "./TabContent.vue?vue&type=style&index=0&id=ecb7f78e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb7f78e"],['__file',"src/components/mdbvue/Components/TabContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecb7f78e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecb7f78e', __exports__)) {
    api.reload('ecb7f78e', __exports__)
  }
  
  module.hot.accept("./TabContent.vue?vue&type=template&id=ecb7f78e&scoped=true", () => {
    api.rerender('ecb7f78e', render)
  })

}


export default __exports__